<template src="./AddressListModal.html"/>
<style lang='scss' scoped src="./AddressListModal.scss"/>

<script>

import {
  SfBar,
  SfButton,
  SfModal,
  SfHeading,
} from '@storefront-ui/vue';
import UserAddress from '@/components/UserAddress.vue';
import Api from "@/api/Api";


export default {
  name: 'AddressListModal',
  components: {
    UserAddress,
    SfHeading,
    SfBar,
    SfButton,
    SfModal
  },
  data() {
    return {
      error: null,
      loadingAddress: false,
      billingAddress: null,
      selectedAddress: null,
      loading: false
    }
  },
  computed: {
    isAddressListModalOpen: {
      get() {
        return this.$store.getters.isAddressListModalOpen
      }
    },
    customer: {
      get() {
        return this.$store.getters.getProfile;
      },
      set() {

      }
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart;
      },
      set() {

      }
    }
  },

  mounted() {

    if (this.customer && this.customer.defaultBillingAddress && this.customer.addresses?.length !== 0) {
      this.selectedAddress = this.customer.defaultBillingAddress;
      if (this.currentCart && this.currentCart.billingAddress) {
        this.selectedAddress = this.currentCart.billingAddress.name;
      }
      /*  if (this.selectedAddress) {
          this.change(this.selectedAddress)
        }*/
    }
  },

  methods: {
    change(address) {
      this.selectedAddress = address;
    },
    setBillingAddress(address) {
      this.selectedAddress = address;
      if (address) {
        this.$emit('changeAddress', {selectedAddress: this.selectedAddress})
        if (this.selectedAddress !== this.currentCart.billingAddress) {
          Api.cart.setBillingAddress(address)
              .then((data) => {
                this.$store.dispatch('setCart', data)
                this.currentCart = data;
                this.toggleAddressListModal()
              })
              .catch((e) => {

                let error = '';
                switch (e.status) {
                  case 401:
                    error = this.$i18n.t('errors.cartAdresse.unauthorized')
                    break;
                  case 409:
                    error = this.$i18n.t('errors.cartAdresse.allReadyExist')
                    break;
                  case 404:
                    error = this.$i18n.t('errors.cartAdresse.notFound')
                    break;
                  case 500:
                    error = this.$i18n.t('errors.server.access')
                    break;
                }
                this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
              })
              .finally(() => {
                this.loadingAddress = false
              })

        }
      } else {
        this.loadingAddress = false
      }
    },
    toggleAddressListModal() {
      this.$store.dispatch('toggleAddressListModal')
    },

  }
};
</script>


